import { StepperSelectionEvent } from '@angular/cdk/stepper';
import {
  AfterViewInit,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewChild
} from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { combineLatest } from 'rxjs';
import { SiteModel, SiteStepperModel } from 'src/app/models/index';
import {
  CommonService,
  PlantServiceService,
  SiteStepperService,
  UtilitiesService
} from 'src/app/services/index';

@Component({
  selector: 'app-setup-project',
  templateUrl: './setup-project.component.html',
  styleUrls: ['./setup-project.component.scss'],
  providers: [SiteStepperService]
})
export class SetupProjectComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('stepper') stepper: any;
  model: SiteModel;
  selectedIndex = 0;
  stepName = '';
  siteId = '';
  //  isLinear = true;
  isEditableStep = false;
  formSteps = [
    {
      label: 'Site Creation',
      path: 'site-creation'
    },
    {
      label: 'Connection Details',
      path: 'connection-details'
    },
    {
      label: 'Shift Details',
      path: 'shift-details'
    },
    {
      label: 'Process and Load Details',
      path: 'process-and-load-details'
    },
    {
      label: 'Group Configuration',
      path: ''
    },
    {
      label: 'Reserves And Sources',
      path: ''
    },
    {
      label: 'Alerts Configuration',
      path: ''
    },
    {
      label: 'Widget Configuration',
      path: 'widget-configuration'
    },
    {
      label: 'Report Configuration',
      path: 'report-configuration'
    },
    {
      label: 'Data Acquisition Layout',
      path: 'data-acquisition-layout'
    },
    {
      label: 'Tree Configuration',
      path: ''
    },
    {
      label: 'Click and Navigation Details',
      path: 'click-and-navigation-details'
    }
  ];
  projectTitle = 'New Project Entry';
  isLinear = false;
  firstFormGroup: UntypedFormGroup;
  secondFormGroup: UntypedFormGroup;
  matStepClass = '';
  constructor(
    private router: Router,
    private activeRoute: ActivatedRoute,
    private siteStepperService: SiteStepperService,
    private plantService: PlantServiceService,
    private commonService: CommonService,
    private utilitiesService: UtilitiesService,
    private elRef: ElementRef,
    private renderer: Renderer2
  ) {
    this.siteStepperService.getStepperSubject().subscribe((data) => {
      if (this.selectedIndex === data.selectedIndex) {
        if (data.siteModel !== null && data.siteModel.siteId !== '') {
          this.enableStepper();
        }
      } else {
        this.selectedIndex = data.selectedIndex;
      }
    });
  }

  ngOnInit() {
    // Combine them both into a single observable
    const urlParams = combineLatest(
      this.activeRoute.params,
      this.activeRoute.queryParams,
      (params, queryParams) => ({ ...params, ...queryParams })
    );
    // Subscribe to the single observable, giving us both
    urlParams.subscribe((routeParams) => {
      if (!this.commonService.isNullOrUndefined(routeParams.siteId)) {
        this.siteId = routeParams.siteId;
        this.plantService.getSiteDetail(this.siteId).subscribe((data) => {
          this.model = <SiteModel>data;
          this.model.siteId = this.siteId;
          this.projectTitle = 'View/Edit Site Entry';
          // this.stepper._steps.first.completed = true;
          this.isEditableStep = true;
          // this.stepper._stateChanged();
          this.siteStepperService.sendStepperSubject(
            new SiteStepperModel(0, this.model)
          );
        });
      } else {
        console.log('SiteId is null');
      }
    });
  }
  ngAfterViewInit() {
    // this.router.navigate(['multi-step-form', 'site-creation']);
    if (this.siteId === '') {
      this.disableStepper();
      this.siteStepperService.sendStepperSubject(new SiteStepperModel(0, null));
    } else {
      this.enableStepper();
    }
    // this.stepper._linear = true;
    this.stepper._getIndicatorType = () => 'number';
    const url = this.commonService.getPlantLogoUrl(this.siteId);
    this.utilitiesService.displayPlantLogo(url);
  }
  private disableStepper = () => {
    this.stepper._steps._results.forEach((step: any, i: number) => {
      if (i > 0) {
        const temp =
          step._stepper._stepHeader._results[i]._elementRef.nativeElement;
        // this.renderer.addClass(temp, 'stepper-disabled');
        this.renderer.setStyle(temp, 'pointer-events', 'none');
        this.renderer.setStyle(temp, 'cursor', 'not-allowed');
        this.renderer.setStyle(temp, 'opacity', '0.6');
      }
    });
  };
  private enableStepper = () => {
    this.stepper._steps._results.forEach((step: any, i: number) => {
      if (i > 0) {
        const temp =
          step._stepper._stepHeader._results[i]._elementRef.nativeElement;
        // this.renderer.addClass(temp, 'stepper-disabled');
        this.renderer.removeStyle(temp, 'pointer-events');
        this.renderer.removeStyle(temp, 'cursor');
        this.renderer.removeStyle(temp, 'opacity');
      }
    });
  };

  ngOnDestroy() {
    this.siteStepperService.unSubscribeStepperSubject();
  }
  // selectionStepChange($event: StepperSelectionEvent) {
  public selectionStepChange($event: StepperSelectionEvent) {
    // if ($event.selectedIndex === 0 || this.siteId === '') { return false; }
    //   this.siteStepperService.sendStepperSubject(new SiteStepperModel($event.selectedIndex, this.model));
    if (this.siteId === '') {
      return false;
    }
    const calledSendStepper = this.siteStepperService.getSendStepper();
    if (calledSendStepper) {
      this.siteStepperService.setSendStepper(false);
    } else {
      this.siteStepperService.sendStepperSubject(
        new SiteStepperModel($event.selectedIndex, this.model)
      );
    }
    // const step = this.formSteps[$event.selectedIndex];
    // this.stepper.selectedIndex = $event.selectedIndex;
    // this.router.navigate(['multi-step-form/', step.path]);
  }
}
